<div class="container">
    <br />
    <div class="row g-0">
        <div class="col-lg-2">
            <img src="assets/images/logo.png" class="img-thumbnail" alt="LogoCamaraDiptuados" />
        </div>
        <div class="col-lg-10">
            <p class="h2" style="text-align: right">
                Diputadas y Diputados Federales que manifiestan su Renuncia Voluntaria a los Apoyos Económicos a que tienen derecho, durante el Proceso Electoral Federal 2023-2024.
            </p>
            <!-- <h2 style="text-align: center">
                Renuncia de apoyos económicos en el Proceso Electoral Federal 2023-2024 en elección consecutiva.
            </h2> -->
        </div>
    </div>
    <br />
    <form [formGroup]="formulario">
        <div class="row mb-3 justify-content-end">
            <div class="col-12 col-lg-4 mb-lg-0 mb-2">
                <input class="form-control me-2" placeholder="Nombre de la diputada o diputado" type="text" formControlName="nombre"
                    maxlength="50" />
                <span *ngIf="campoNoEsValido('nombre')" class="text-danger">{{
                    procendenciaMSG }}</span>
            </div>
            <div class="col-6 col-md-2 col-lg-1">
                <button type="submit" at-raised-button color="success" class="col-12 btn btn-success"
                    (click)="buscarContendientes()">
                    Buscar
                </button>
            </div>
            <!-- <div class="col-6 col-md-2 col-lg-2">
                <button type="submit" at-raised-button color="success" class="col-12 btn btn-success"
                    (click)="limpiarFormulario()">
                    Limpiar
                </button>
            </div> -->
        </div>
    </form>
    <div class="row">
        <!-- <p style="color: black; text-align: right" class="text-muted">
            Total de registros <b>{{contendientes.length}}</b>
            <br>
            Actualizado al 6 de junio 2021
        </p> -->

        <div class="table-responsive">
            <table class="table">
                <thead class="table green">
                    <tr>
                        <th class="enc_centrado" scope="col">N°</th>
                        <th class="enc_centrado" scope="col">Diputada / Diputado</th>
                        <th class="enc_centrado" scope="col">Grupo Parlamentario</th>
                        <th class="enc_centrado" scope="col">Entidad Federativa</th>
                        <th class="enc_centrado" scope="col">Distrito / Circunscripción</th>
                        <th class="enc_centrado" scope="col">Tipo de Elección</th>
                        <!-- <th class="enc_centrado" scope="col">En funciones / Licencia</th> -->
                        <!-- <th class="enc_centrado" scope="col">Renuncia a Apoyos</th> -->
                        <!-- <th class="enc_centrado" scope="col">Renuncia</th> -->
                        <th class="enc_centrado" scope="col">Documento</th>
                    </tr>
                </thead>
                <tbody *ngIf="contendientes.length === 0">
                    <tr>
                        <td colspan="12" class="enc_centrado" style="align-items: center">
                            <span>Actualmente no hay registros</span>
                        </td>
                    </tr>
                </tbody>
                <tbody *ngFor="let c of contendientes; let i = index">
                    <tr>
                        <td class="enc_centrado">
                            <b>{{ c.Numero }}</b>
                        </td>
                        <td>
                            {{ c.NombreDiputado }}<span *ngIf="c.NotaLicencia">**</span>
                        </td>
                        <td class="enc_centrado">{{ c.GrupoParlamentario }}</td>
                        <td class="enc_centrado">{{ c.EntidadFederativa }}</td>
                        <td class="enc_centrado">{{ c.DistritoCircuns }}</td>
                        <td class="enc_centrado">{{ c.TipoEleccion }}</td>
                        <!-- <td class="enc_centrado">{{ c.EnFunciones }}</td> -->
                        <!-- <td style="text-align: center">
                        <span *ngIf="c.Renuncia === 1">Sí</span
            ><span *ngIf="c.Renuncia === 0">No</span>
                    </td> -->
                        <!-- <td class="text-center">Sí                 </td> -->

                        <td class="enc_centrado">
                            <div class="example-button-container" style="text-align: center">
                                <a *ngIf="c.SFTPDocumento1" href="{{c.SFTPDocumento1}}" target="_blank">
                                    <button title="Descargar documento de Renuncia a Apoyos"
                                        class="btn btn-success text-white"
                                        aria-label="Icon button descargar documento de Renuncia a Apoyos">
                                        Descargar
                                    </button></a>

                                <!-- <button type="button" class="btn btn-primary" *ngIf="c.SFTPDocumento1"
                                    (click)="VerCarta(c.Oid)">
                                    Ver
                                </button> -->
                                <a *ngIf="!c.SFTPDocumento1" target="_blank">
                                    <button title="Sin documento de renuncia a apoyos" class="btn btn-warning btn-sm"
                                        aria-label="No cuenta con documento de Renuncia a Apoyos">
                                        Sin documento
                                    </button></a>
                            </div>
                            <!-- <a *ngIf="c.Id !== 0; else sinPerfil" href="http://sitl.diputados.gob.mx/LXV_leg/curricula.php?dipt={{
                c.Id
              }}" target="_blank">
                                <mat-icon matTooltip="Ir al perfil del diputado"
                                    matTooltipClass="example-tooltip-darkgreen" [matTooltipShowDelay]="showDelay.value"
                                    [matTooltipHideDelay]="hideDelay.value"
                                    style="color: darkgreen">ads_click</mat-icon>
                            </a>
                            <ng-template #sinPerfil><button mat-mini-fab
                                    style="color: grey; background-color: lightgray"
                                    matTooltip="No se encuentra en lista del INE" matTooltipClass="example-tooltip-red"
                                    [matTooltipShowDelay]="showDelay.value" [matTooltipHideDelay]="hideDelay.value"
                                    aria-label="Example icon button with a home icon">
                                    <mat-icon>link_off</mat-icon>
                                </button></ng-template> -->
                        </td>
                    </tr>
                    <tr *ngIf="c.Notas !== null && c.Notas">
                        <td colspan="12">
                            <table class="table">
                                <thead class="table-light">
                                    <tr>
                                        <td><b>Notas:</b> {{ c.Notas }}</td>
                                    </tr>
                                </thead>
                            </table>
                        </td>
                    </tr>
                </tbody>

                <tfoot>
                    <td colspan="12">
                        <p> <b>**Nota:</b> Las y los diputados que solicitan licencia, dejan de recibir recursos provenientes de 
                            la Cámara de Diputados a partir de la fecha en que la misma se aprueba. Presentar la carta de 
                            “Renuncia a Apoyos”, es potestativo de las y los legisladores en funciones.</p>
                    </td>


                </tfoot>
            </table>
        </div>
    </div>
</div>
<!-- <div class="col-12 text-end">
    <small class=" text-muted">
        <span>

            Regla para <b>"Renuncia a apoyos"</b>:
        </span>
        <br>
        <ul>
            <li><span class="badge bg-success">Si</span>, Si renuncia a apoyos y subió un Docto. de Renuncia de apoyos
            </li>
            <li><span class="badge bg-secondary">No</span>,Si no tiene un documento en el que renuncia a apoyos</li>
        </ul>
    </small>
</div> -->


<!-- <td style="text-align: center">
                        <button *ngIf="c.Licencia === 1" mat-mini-fab style="background-color: #228b22; color: white" (click)="downloadBase64File(c)">
              <i class="fas fa-file-download"></i></button
            ><span class="spacer"></span>
            <button
              *ngIf="c.Funciones === 1"
              mat-mini-fab
              style="background-color: #ffd700; color: black"
              (click)="downloadBase64File(c)"
            >
              <mat-icon>file_download</mat-icon>
            </button>
                            <ng-template #noFiles>
                                <td></td>
                            </ng-template>
                    </td> -->